// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"73":"0f4ae6ff97bc765c271b","149":"27d03b963e575804210d","488":"b12bf8426938cb772868","653":"9236d7f10b2769c4afd7","707":"737f5265d01e7726fa01","794":"6cec8edec6d17e3a5982","919":"6b5674d43c3b3dff7163","940":"52bddeb81b97fb740056"}[chunkId] + ".js";
};